import { AvailableWidget } from '../constants';
import { IAvailableWidgetsAction } from '../interfaces/actions';

export const listAvailableWidgets = (): IAvailableWidgetsAction => ({ type: AvailableWidget.LIST });


// WEBPACK FOOTER //
// ./src/actions/AvailableWidget.ts